import React from 'react'
import './banner.scss'

const Banner = ({
	theme,
	suptitle,
	title,
	text,
	btnClass,
	linkhref,
	linktext,
}) => {
	return (
		<div className={`banner banner-${theme}`}>
			<div className="section_inner">
				<span className="banner_supTitle">{suptitle}</span>
				<h2 className="banner_title">{title}</h2>
				<p className="banner_text">{text}</p>
				<a href={linkhref} className={`banner_link btn btn-${btnClass}`}>
					{linktext}
				</a>
			</div>
		</div>
	)
}

export default Banner
